"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGridItemStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ButtonGridItemStyled = _styledComponents["default"].button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: 0.2rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 0;\n\tborder-radius: 3px;\n\tbackground: ", ";\n\tbox-shadow: ", ";\n\tcursor: pointer;\n\tmin-height: 4rem;\n\tcolor: ", ";\n\t* {\n\t\tcolor: ", " !important;\n\t}\n"])), function (props) {
  return props.isSelected && !props.withBorder ? props.theme.colors.maxBluePurple : props.theme.colors.light;
}, function (props) {
  return props.isSelected && props.withBorder ? "0 0 0 2px ".concat(props.theme.colors.maxBluePurple) : '';
}, function (props) {
  return props.isSelected && !props.withBorder ? props.theme.colors.light : props.theme.colors.dark;
}, function (props) {
  return props.isSelected ? props.theme.colors.light : '';
});
exports.ButtonGridItemStyled = ButtonGridItemStyled;